export const INQUIRY_TYPE_LABELS: Record<string, string> = {
  operation_confirmation: "操作確認",
  bug: "不具合",
  improvement: "改善要望",
  consultation: "相談",
  other: "その他",
};

const INQUIRY_TYPE_VALUES_BY_LABEL: Record<string, string> = Object.entries(
  INQUIRY_TYPE_LABELS,
).reduce((result, [value, label]) => ({ ...result, [label]: value }), {});

export const inquiryTypeValuesFromFilter = (values: string[]): string[] =>
  Array.from(
    new Set(
      values
        .map((value) => INQUIRY_TYPE_VALUES_BY_LABEL[value] || value)
        .filter((value) =>
          Object.prototype.hasOwnProperty.call(INQUIRY_TYPE_LABELS, value),
        ),
    ),
  );
